import { api, ReactQueryOptions, RouterInputs, RouterOutputs } from '@api'
import { UseTRPCInfiniteQueryOptions } from '@trpc/react-query/shared'
import { TRPCClientErrorLike } from '@trpc/client'

type inputPublicType = RouterInputs['ToyManager']['getList']
type outputPublicType = RouterOutputs['ToyManager']['getList']

type optionsInfinityPublicType = UseTRPCInfiniteQueryOptions<'ToyManager.getList', inputPublicType, outputPublicType, TRPCClientErrorLike<any>>

export const useGetPublicToysInfinity = (input: inputPublicType, options?: optionsInfinityPublicType) =>
    api.ToyManager.getList.useInfiniteQuery(input, {
        ...options,
        queryKey: ['ToyManager.getList', input],
        getNextPageParam: (firstPage) => firstPage.nextCursor,
        refetchOnWindowFocus: false,
        initialCursor: undefined,
        staleTime: 15 * 60 * 1000, // 15 mins
    })

type inputPrivateType = RouterInputs['ToyManager']['_getList']
type outputPrivateType = RouterOutputs['ToyManager']['_getList']
type optionsInfinityPrivateType = UseTRPCInfiniteQueryOptions<'ToyManager._getList', inputPrivateType, outputPrivateType, TRPCClientErrorLike<any>>

export const useGetPrivateToysInfinity = (input: inputPrivateType, options?: optionsInfinityPrivateType) =>
    api.ToyManager._getList.useInfiniteQuery(input, {
        ...options,
        queryKey: ['ToyManager._getList', input],
        getNextPageParam: (firstPage) => firstPage.nextCursor,
        refetchOnWindowFocus: false,
        initialCursor: undefined,
        staleTime: 15 * 60 * 1000, // 15 mins
    })

type OptionsPublicType = ReactQueryOptions['ToyManager']['getList']
export const useGetPublicToys = (input: inputPublicType, options?: OptionsPublicType) => {
    return api.ToyManager.getList.useQuery(input, {
        ...options,
        queryKey: ['ToyManager.getList', input],
        staleTime: 15 * 60 * 1000, // 15 mins
    })
}

type OptionsPrivateType = ReactQueryOptions['ToyManager']['_getList']
export const useGetPrivateToys = (input: inputPrivateType, options?: OptionsPrivateType) => {
    return api.ToyManager._getList.useQuery(input, {
        ...options,
        queryKey: ['ToyManager._getList', input],
        staleTime: 15 * 60 * 1000, // 15 mins
    })
}
